import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  @import url('https://fonts.googleapis.com/css?family=Roboto+Condensed:400,700');
`;

/* ------------------------------------------------------------------------ */
/* ----------------------------- Card styles ----------------------------- */
/* ------------------------------------------------------------------------ */

/* Card Header Styles */
const Card = styled.div`
  background-color: ${(props) => props.theme.white};
  color: ${(props) => props.theme.black};
  font-size: 16px;
  margin: 30px 0 50px;
  max-width: 100%;
  width: 100%;
`;

const Title = styled.span`
  border-bottom: 2px solid ${(props) => props.theme.black};
  display: block;
  font-family: ${(props) => props.theme.fontSourceSansPro};
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 1.4;
  margin: 0 0 0.625rem;
  padding-bottom: 0.625rem;
  text-align: center;
  text-transform: uppercase;

  @media screen and (min-width: ${(props) => props.theme.md}) {
    font-size: 1.25rem;
  }

  @media screen and (min-width: ${(props) => props.theme.lg}) {

    /* ----- Max-width Hub ----- */
    .election-hub--max.election-hub--min.election-hub--count-3 &,
    .election-hub--max.election-hub--min.election-hub--count-4 & {
      font-size: 0.75rem;
    }
  }

  /* ----- Small-width Hub ----- */
  .election-hub--min & {
    font-size: 0.95rem;
  }

  /* ----- With subtitle ----- */
  .election-hub--card__with-subtitle & {
    margin-bottom: 6px;
  }
`;

const SubTitle = styled.span`
  border-top: none;
  color: ${(props) => props.theme.black};
  display: block;
  font-family: ${(props) => props.theme.fontSourceSansPro};
  font-size: 0.813rem;
  font-weight: 600;
  line-height: 1.15;
  margin: 0 0 0 0.625rem;
  padding: 0 1.125rem;
  text-transform: initial;

  @media screen and (min-width: ${(props) => props.theme.md}) {

    /* ----- Has Photos ----- */
    .election-hub--race-card__with-photos & {
      padding-left: 3.3125rem;
    }
  }
`;

const Description = styled.span`
  color: ${(props) => props.theme.black};
  display: block;
  font-family: ${(props) => props.theme.fontPrimary};
  font-size: 0.85rem;
  font-weight: 400;
  line-height: 1.3;
  margin-bottom: 0.6rem;
  padding: 0 1.125rem;
  text-align: left;

  @media screen and (min-width: ${(props) => props.theme.md}) {
    /* ----- Has Photos ----- */
    .election-hub--race-card__with-photos & {
      padding-left: 3.3125rem;

      /* ----- Small-width Hub ----- */
      .election-hub--min & {
        padding-left: 1.125rem;
      }
    }
  }
`;

/* Candidate/Ballot Item styles */
/* eslint-disable max-len */
const HeaderWrap = styled.div`
  align-items: center;
  color: ${(props) => props.theme.black};
  display: inline-flex;
  width: 100%;
  min-height: ${(props) => props.theme.rowHeight};
  padding-left: 0;

  @media screen and (min-width: ${(props) => props.theme.md}) {
    /* ----- Has Photos ----- */
    .election-hub--race-card__with-photos & {
      padding-left: 2.1875rem;

      &.party__has-candidate-image {
        padding-left: 0.25rem;
      }
    }
  }

  /* ----- Small-width Hub ----- */
  .election-hub--min .election-hub--race-card__with-photos & {
    padding-left: 0;
  }
`;
/* eslint-enable max-len */

const ItemTitle = styled.div`
  font-family: ${(props) => props.theme.fontSourceSansPro};
  font-size: 0.875rem;
  font-weight: 700;
  hyphens: auto;
  line-height: 1;
  margin-right: 5px;
  text-transform: uppercase;

  /* ----- Party Colors ----- */
  .party__democrat & {
    color: ${(props) => props.theme.democrat};
  }
  .party__republican & {
    color: ${(props) => props.theme.republican};
  }

  /* ----- Candidate Name ----- */
  .candidate__first-name {
    display: none;

    @media screen and (min-width: ${(props) => props.theme.md}) {
      display: inline;

      /* ----- Has Photos ----- */
      .election-hub--min & {
        display: none;
      }
    }
  }

  @media screen and (min-width: ${(props) => props.theme.md}) {
    font-size: 0.875rem;
  }

  /* ----- Small-width Hub ----- */
  .election-hub--min & {
    font-size: 0.75rem;
  }
`;

const ItemStatus = styled.div`
  align-items: center;
  color: ${(props) => props.theme.black};
  display: ${(props) => ('race' === props.type ? 'none' : 'flex')};
  font-weight: 700;
  justify-content: center;
  margin-left: ${(props) => ('measure' === props.type ? '0' : '0.625rem')};
  padding-right: ${(props) => ('race' === props.type ? '0' : '1rem')};
  text-transform: uppercase;

    /* ----- Winning Candidate ----- */
  .candidate__winner & {
    display: inline-flex;
  }

  svg {
    height: 17px;
    width: 17px;

    .candidate__winner.party__democrat & {
      fill: ${(props) => props.theme.democrat};
    }

    .candidate__winner.party__republican & {
      fill: ${(props) => props.theme.republican};
    }
  }

  span {
    margin-top: 2px;
  }
`;

export default {
  Card,
  Description,
  GlobalStyles,
  HeaderWrap,
  ItemStatus,
  ItemTitle,
  SubTitle,
  Title,
};
